import { del, get, post, put } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { ApiResponseStatus } from "../constants/enums";
import { User } from "../models/User";
import { generateArrayQueryParamsString } from "../helpers";
import { simpleResponse } from "./api-helpers";

export async function getUsers(types) {
  const queryParams = generateArrayQueryParamsString(types, "type");
  return await get(`users${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      let usersAndCounts = { users: [], counts: {} };
      if (responseIsSuccessful(res) && res.data.users) {
        if (res.data.users) {
          usersAndCounts.users = res.data.users.map(u => {
            if (u.primary_phone && u.primary_phone.length) {
              u.primary_phone = u.primary_phone[0];
            }
            return new User(u);
          });
        }
        if (res.data.counts) {
          res.data.counts.crew =
            res.data.counts.crew_leader + res.data.counts.crew_supervisor;
          usersAndCounts.counts = res.data.counts;
        }
      }
      return usersAndCounts;
    })
    .catch(err => {
      console.log(err);
      return { users: [], counts: {} };
    });
}

export async function storeUser(user) {
  return await post(
    "users",
    { user_params: user },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function updateUser(user) {
  return await put(
    `users/${user.id}`,
    { user_params: user },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function deleteUser(user) {
  return await del(`users/${user.id}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function updatePassword(data) {
  return await simpleResponse(
    post(
      "update-password",
      {
        old_password: data.currentPassword,
        new_password: data.newPassword
      },
      window.localStorage.apiToken
    )
  );
}
